// Currency unit names mapping
const CURRENCY_UNITS = {
  // Major currencies
  'USD': { major: 'Dollar', minor: 'Cent', minorPlural: 'Cents' },
  'EUR': { major: 'Euro', minor: 'Cent', minorPlural: 'Cents' },
  'GBP': { major: 'Pound', minor: 'Penny', minorPlural: 'Pence' },
  'INR': { major: 'Rupee', minor: 'Paisa', minorPlural: 'Paise' },
  'AUD': { major: 'Dollar', minor: 'Cent', minorPlural: 'Cents' },
  'CAD': { major: 'Dollar', minor: 'Cent', minorPlural: 'Cents' },
  'JPY': { major: 'Yen', minor: 'Sen', minorPlural: 'Sen' },
  'CNY': { major: 'Yuan', minor: 'Fen', minorPlural: 'Fen' },
  'CHF': { major: 'Franc', minor: 'Centime', minorPlural: 'Centimes' },
  'SGD': { major: 'Dollar', minor: 'Cent', minorPlural: 'Cents' },
  'NZD': { major: 'Dollar', minor: 'Cent', minorPlural: 'Cents' },
  'HKD': { major: 'Dollar', minor: 'Cent', minorPlural: 'Cents' },
  'KRW': { major: 'Won', minor: 'Jeon', minorPlural: 'Jeon' },
  'MXN': { major: 'Peso', minor: 'Centavo', minorPlural: 'Centavos' },
  'BRL': { major: 'Real', minor: 'Centavo', minorPlural: 'Centavos' },
  'ZAR': { major: 'Rand', minor: 'Cent', minorPlural: 'Cents' },
  'AED': { major: 'Dirham', minor: 'Fils', minorPlural: 'Fils' },
  'SAR': { major: 'Riyal', minor: 'Halala', minorPlural: 'Halalas' },
  // Default fallback
  'DEFAULT': { major: 'Unit', minor: 'Subunit', minorPlural: 'Subunits' }
};

// Convert number to words (for amount display)
export function numberToWords(num, currencyCode = 'USD') {
  if (num === 0) return 'Zero';
  
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion'];

  function convertChunk(n) {
    if (n === 0) return '';
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + convertChunk(n % 100) : '');
  }

  // Get currency units
  const currency = CURRENCY_UNITS[currencyCode] || CURRENCY_UNITS['DEFAULT'];
  
  // Split into major and minor units
  const majorUnits = Math.floor(num);
  const minorUnits = Math.round((num - majorUnits) * 100);

  let result = '';

  if (currencyCode === 'INR') {
    // Indian numbering system: Crore / Lakh / Thousand / Hundred.
    const indianWords = (n) => {
      if (n === 0) return '';
      const crore = Math.floor(n / 10000000);
      const lakh = Math.floor((n % 10000000) / 100000);
      const thousand = Math.floor((n % 100000) / 1000);
      const rest = n % 1000;
      const parts = [];
      if (crore > 0) parts.push(indianWords(crore) + ' Crore');
      if (lakh > 0) parts.push(convertChunk(lakh) + ' Lakh');
      if (thousand > 0) parts.push(convertChunk(thousand) + ' Thousand');
      if (rest > 0) parts.push(convertChunk(rest));
      return parts.join(' ');
    };
    result = indianWords(majorUnits) || 'Zero';
  } else {
    // International numbering system: Thousand / Million / Billion.
    let chunkCount = 0;
    let tempNum = majorUnits;
    while (tempNum > 0) {
      const chunk = tempNum % 1000;
      if (chunk !== 0) {
        const chunkWords = convertChunk(chunk);
        result = chunkWords + (thousands[chunkCount] ? ' ' + thousands[chunkCount] : '') + (result ? ', ' + result : '');
      }
      tempNum = Math.floor(tempNum / 1000);
      chunkCount++;
    }
    result = result || 'Zero';
  }

  result += ' ' + currency.major + (majorUnits !== 1 ? 's' : '');

  // Add minor units if present
  if (minorUnits > 0) {
    result += ' and ' + convertChunk(minorUnits) + ' ' + (minorUnits !== 1 ? currency.minorPlural : currency.minor);
  }

  return result + ' Only';
}
